import React from 'react';

import { StyledPriceCols } from './StyledPriceCols';

const PriceCols = () => {
  const entries = [
    {
      "title": "BASE",
      "text01": "Shared server*<br/><small>*cheaper but with may incur queues</small>",
      "text02": "Monthly subscription"
    },
    {
      "title": "STANDARD",
      "text01": "Exclusive use",
      "text02": "Monthly subscription"
    },
    {
      "title": "PREMIUM",
      "text01": "Run your projects on every device that has an internet connection.",
      "text02": "Daily subscription"
    },
    {
      "title": "CUSTOM",
      "text01": "Run your projects on every device that has an internet connection.",
      "text02": "Daily subscription"
    },
  ]
  return (
    <StyledPriceCols>
      <h6 className='big--title tabs-title'>Plans and Prices</h6>
      <div className='tabs-wrap'>
      {
        entries.map((entry, i) => {
          return  <div className="home--col" key={i}>
                    {
                      i <= 2 &&
                      <div className='charts-wrap'>
                        <div className='circle'>
                          <span className='inner selected'></span>
                        </div>
                        <div className='circle' >
                          <span className={i >= 1 ? 'inner selected' : 'inner'}></span>
                        </div>
                        <div className='circle'>
                          <span className={i >= 2 ? 'inner selected' : 'inner'}></span>
                        </div>
                      </div>
                    }
                    {
                      i === 3 &&
                      <div className='charts-wrap custom--header'></div>
                    }
                    <p className={i === 3 ?"preset-10 title-pack title-pack-custom":"preset-10 title-pack"}>{entry.title}</p>
                    <div className="col-separator"></div>
                    <p className="preset-12 grey text-01"
                    dangerouslySetInnerHTML={{ __html: 
                      entry.text01
                    }}></p>
                    <div className="col-separator"></div>
                    <p className="preset-12 grey">{entry.text02}</p>
                  </div>
        })
      }
      </div>
      
    </StyledPriceCols>
  )
}

export default PriceCols;